const State = require('../helpers.js').State;

module.exports = State({
    slide: [0, 0],
    isLoading: true,
    loaderText: 'Te rugăm să aștepți...',
    flowId: '',
    showInfo: false,
    infoMessage: '',
});

//Iti pregatim oferta...
